import { render, staticRenderFns } from "./AiFooter.vue?vue&type=template&id=794e83cd&scoped=true"
import script from "./AiFooter.vue?vue&type=script&lang=js"
export * from "./AiFooter.vue?vue&type=script&lang=js"
import style0 from "./AiFooter.vue?vue&type=style&index=0&id=794e83cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794e83cd",
  null
  
)

export default component.exports